import {has, isEmpty, last, map} from 'underscore'
import {v4 as uuid} from 'uuid'
import errorTypes from '../../static/base-error-types'

const UNKNOWN_MESSAGE = 'An unknown error has occurred'

const UNKNOWN_ERROR = {
    type: errorTypes.UNKNOWN,
    message: UNKNOWN_MESSAGE
}

export const mapErrorMessage = (error) => {
    const status = (error && error.status) || 500
    let message = UNKNOWN_MESSAGE

    if (error.message && !status.toString().match(/50\d/)) {
        message = error.message
    }

    return message.slice(-1) === '.'
        ? message
        : `${message}.`
}

export const mapErrorInfo = (error) => {
    if (has(error, 'ref') && error.ref) {
        return `If this problem persists please contact your system administrator, with the following reference: ${error.ref}`
    }

    return `If this problem persists please contact your system administrator.`
}

export default {
    mapErrorMessage,
    mapError: (err) => {
        const response = err.response

        const status = has(response, 'status') ? response.status : 500

        const contentTypeHeader = has(response, 'headers')
            ? response.headers['content-type']
            : false

        const isJson = contentTypeHeader
            && contentTypeHeader.indexOf('application/json') !== -1

        let data = isJson && has(response, 'data')
            ? has(response.data, 'error')
                ? response.data.error
                : response.data
            : UNKNOWN_ERROR

        let errors = has(data, 'errors') && !isEmpty(data.errors)
            ? data.errors
            : []

        if (typeof data === 'string' && isJson) {
            data = {message: data}
        }

        data = {
            ...data,
            status,
            originalMessage: data.message,
            message: mapErrorMessage(data),
            info: mapErrorInfo(data)
        }

        switch (data.type) {
            case errorTypes.VALIDATION:
                data.color = 'warning'
                errors = map(errors, (error) => {
                    const field = !isEmpty(error.field)
                        ? last(error.field.replace('_uuid', '').split('.'))
                        : ''

                    return {...error, field}
                })
                break
            case errorTypes.PARTIAL_INVALID_UUIDS:
                data.color = 'warning'
                errors = [{field: 'Form', message: data.message}]
                break
            case errorTypes.UNKNOWN:
            default:
                data.color = 'error'
        }

        return {uuid: uuid(), ...data, errors: errors, response: err}
    }
}
